export const PaymentTrackerAlertLabel = {
    OK: "OK",
    FAILED: "FAILED",
    WILL_FAIL: "WILL_FAIL"
}